import { css } from "@vitality-ds/system";
import { getColorVariant } from "./helpers";
export default css({
  padding: "$lg",
  borderRadius: "$large",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "$md",
  width: "100%",
  boxSizing: "border-box",
  variants: {
    severity: {
      info: {},
      warning: {},
      critical: {},
      success: {},
      accent: {},
      brand: {},
      primary: {},
      neutral: {}
    },
    size: {
      compact: {
        backgroundColor: "transparent",
        padding: 0
      },
      blockCompact: {
        flexDirection: "row",
        padding: "$sm"
      },
      "default": {}
    }
  },
  compoundVariants: [{
    size: "default",
    severity: "warning",
    css: getColorVariant("warning")
  }, {
    size: "default",
    severity: "success",
    css: getColorVariant("success")
  }, {
    size: "default",
    severity: "info",
    css: getColorVariant("info")
  }, {
    size: "default",
    severity: "critical",
    css: getColorVariant("critical")
  }, {
    size: "default",
    severity: "accent",
    css: getColorVariant("accent")
  }, {
    size: "default",
    severity: "brand",
    css: getColorVariant("brand")
  }, {
    size: "default",
    severity: "primary",
    css: getColorVariant("primary")
  }, {
    size: "default",
    severity: "neutral",
    css: getColorVariant("neutral")
  }, {
    size: "blockCompact",
    severity: "warning",
    css: getColorVariant("warning")
  }, {
    size: "blockCompact",
    severity: "success",
    css: getColorVariant("success")
  }, {
    size: "blockCompact",
    severity: "info",
    css: getColorVariant("info")
  }, {
    size: "blockCompact",
    severity: "critical",
    css: getColorVariant("critical")
  }, {
    size: "blockCompact",
    severity: "accent",
    css: getColorVariant("accent")
  }, {
    size: "blockCompact",
    severity: "brand",
    css: getColorVariant("brand")
  }, {
    size: "blockCompact",
    severity: "primary",
    css: getColorVariant("primary")
  }, {
    size: "blockCompact",
    severity: "neutral",
    css: getColorVariant("neutral")
  }]
});